import { TRACE_EVENT_TYPES, displayEventType } from '../constants/eventTypes.js';

/**
 * The trace steps an event carries, or `[]`. Read from `detail.trace`, which is
 * where the HITL mapper puts `render.trace` (`mapHitlToEvent.js`).
 *
 * ⚠️ No endpoint returns this today: `render.trace` never arrives (the HITL tasks
 * in the tenant are our own test data, created without it) and no governance
 * endpoint has a source-workflow concept at all. So this is `[]` in practice
 * until CT-4867 defines the `render` contract per type (question P4).
 */
export function workflowTraceSteps(event) {
  const steps = event?.detail?.trace;
  return Array.isArray(steps) ? steps : [];
}

/**
 * Whether to offer Trace for an event: its type must be one that can have a
 * workflow AND it must actually carry the steps — the prototype gates per event
 * (`event.sourceWorkflow`), so two rows of the same type can differ.
 *
 * Interim wire types are bucketed through {@link displayEventType} so a
 * `change_request` row is judged as the Gov Review it renders as.
 */
export function eventHasWorkflowTrace(event) {
  if (!event) return false;
  if (!TRACE_EVENT_TYPES.has(displayEventType(event.type))) return false;
  return workflowTraceSteps(event).length > 0;
}

/** Heading for the trace panel: the workflow reference and name, when known. */
export function workflowTraceLabel(event) {
  const detail = event?.detail ?? {};
  return {
    reference: detail.traceRef ?? null,
    name: detail.workflow ?? null,
  };
}
